import { combineReducers } from "redux";
import applicationState from "./application/application-reducer";
import authState from "./auth/auth-reducer";
import candidateState from "./candidate/candidate-reducer";
import companyState from "./company/company-reducer";
import eventState from "./event/event-reducer";
import jobBoardState from "./job-board/job-board-reducer";
import loadState from "./load/load-reducer";
import signInState from "./sign-in/sign-in-reducer";
import tabChangedState from "./tab-changed/tab-changed-reducer";
import planState from "./plan/plan-reducer";
import companyProfileState from "./company-profile/company-profile.reducer";
import commonState from "./common/common-reducer";
import npsState from "./nps/nps-reducer";


const reducers = combineReducers({
  authState,
  signInState,
  commonState,
  eventState,
  candidateState,
  companyState,
  tabChangedState,
  loadState,
  jobBoardState,
  companyProfileState,
  applicationState,
  npsState,
  planState
});

export default reducers;
